import useAppealPayment from '@/apis/payments/hooks/useAppealPayment'
import { DOCUMENT_TYPES, PAYMENT_TYPES } from '@/apis/providers/types/provider.types'
import CreateReimbursementForm, {
  ReimbursementDetails,
} from '@/app/pages/reimbursements/new/pages/create_reimbursement_form'
import { PaymentDetail } from '@/schemas/payments.schema'
import { useState } from 'react'
import PaymentAppealSuccess from '../payment_appeal_success'
import ExplainAppealPage from './_components/explain_appeal'

type Props = {
  payment: PaymentDetail
}

export function AppealReimbursementPage(props: Props) {
  const { payment } = props
  const [appealReason, setAppealReason] = useState<string>('')
  const [appealStep, setAppealStep] = useState<'explain-appeal' | 'flow'>(
    'explain-appeal'
  )

  const appealMutation = useAppealPayment()

  const FORCE_UPDATE_APPEAL_TO_IN_APPEAL_STATUS = 3

  function handleAppealSubmit(data: ReimbursementDetails) {
    appealMutation.mutate({
      payment_id: payment.payment_id,
      program_id: payment.program_id,
      type: PAYMENT_TYPES.REIMBURSEMENT,
      store_name: data.store_name,
      total_amount: data.amount,
      applicant_appeal_message: appealReason,
      files: data.documents.map((file) => ({
        document_type: DOCUMENT_TYPES.INVOICE,
        file_name: file,
      })),
      global_expense_categories: data.expenseCategories.map((category) => ({
        id: category.id,
        amount: category.amount,
      })),
      comments: data.comments,
      invoice_quote: data.invoiceNumber,
      status: FORCE_UPDATE_APPEAL_TO_IN_APPEAL_STATUS,
      purses: data.purses.map((purse) => ({
        purse_id: purse.purse_id,
        amount: purse.amount,
      })),
    })
  }

  if (appealStep === 'explain-appeal') {
    return (
      <ExplainAppealPage
        onSubmit={(appealReason) => {
          setAppealReason(appealReason.reasonForAppeal)
          setAppealStep('flow')
        }}
      />
    )
  }

  if (appealMutation.status === 'success') {
    return <PaymentAppealSuccess />
  }

  return (
    <CreateReimbursementForm
      mutationStatus={appealMutation.status}
      onSubmit={(data) => {
        handleAppealSubmit(data)
      }}
      defaultValues={{
        amount: payment.total_amount,
        comments: '',
        expenseCategories: payment.expense_categories.map((category) => ({
          id: category.id,
          name: category.name,
          amount: category.amount,
        })),
        documents: payment.payment_documents.map((doc) => doc.path),
        invoiceNumber: payment.invoice_quote ?? '',
        store_name: payment.store_name ?? '',
        purses: payment.purse_movements.map((purse) => ({
          amount: purse.amount,
          isSelected: true,
          hasBeenManuallyEdited: false,
          name: purse.name,
          purse_id: purse.purse_id,
        })),
      }}
    />
  )
}
